import React, { useState } from 'react';
import { Overlay, Popover, Table } from 'react-bootstrap';
import toPairs from 'lodash/toPairs';
import capitalize from 'lodash/capitalize';
import { faCheck } from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Choice({ choice, isSelected, panelPosition, handleSelect }) {
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);

  const showOverlay = (event) => {
    setShow(true);
    setTarget(event.target);
  };

  return (
    <li
      onClick={() => handleSelect(choice.value)}
      onMouseOver={showOverlay}
      onMouseOut={() => setShow(false)}
    >
      {choice.label} {isSelected && <FontAwesomeIcon icon={faCheck} />}
      <Overlay
        show={show}
        target={target}
        placement={panelPosition === 'left' ? 'right' : 'left'}
        animation={false}
        popperConfig={{
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundariesElement: 'viewport',
              },
            },
          ],
        }}
      >
        <Popover
          id={`popover-${choice.value}`}
          title={choice.label}
          placement="right"
          className="workarea-select-details-popover"
        >
          <Popover.Header className="text-center">
            {choice.label}
          </Popover.Header>
          <Popover.Body>
            {choice.image && (
              <img
                src={choice.image}
                alt={choice.image}
                className="img-responsive"
              />
            )}
            {choice.description && <p>{choice.description}</p>}
            {choice.hasOwnProperty('stats') && (
              <Table size="sm">
                <tbody>
                  {toPairs(choice.stats).map((stat) => (
                    <tr key={stat[0]}>
                      <td>{capitalize(stat[0])}</td>
                      <td>{stat[1]}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Popover.Body>
        </Popover>
      </Overlay>
    </li>
  );
}

export default Choice;
